module.exports = __webpack_public_path__ + "img/Electrodiogram.9fd7c294.png";